import { IPrinterDevice, PrinterDevice } from "./printer-device";

export interface IMobileLoginQrCode {
    userName: string;
    token: string;
    printer: IPrinterDevice;
}

export class MobileLoginQrCode {
    private readonly _userName: string;
    private readonly _mobileToken: string;
    private readonly _printer?: PrinterDevice;

    constructor(userName: string, mobileToken: string, printer?: PrinterDevice) {
        this._userName = userName;
        this._mobileToken = mobileToken;
        this._printer = printer;
    }

    public static fromJSON(rawData: string) {
        try {
            const data = JSON.parse(rawData) as IMobileLoginQrCode;

            if (!data.userName || !data.token) {
                return null;
            }

            return new MobileLoginQrCode(data.userName, data.token, data.printer ?
                PrinterDevice.fromData(data.printer) : undefined);
        } catch (_err) {
            return null;
        }
    }

    public toData() {
        return {
            app: "Dropshipment",
            userName: this._userName,
            token: this._mobileToken,
            printer: this._printer?.toData(),
        } as IMobileLoginQrCode;
    }

    get userName(): string {
        return this._userName;
    }

    get mobileToken(): string {
        return this._mobileToken;
    }

    get printer(): PrinterDevice | undefined {
        return this._printer;
    }
}
